<template>
  <div class="min-h-screen p-8 product bg-white">
    <div class="mb-10">
      <p class="text-center font-bold text-gray-800 text-3xl">{{numberFormat(products.total_products, '0,0')}}</p>
      <p class="text-center font-light text-gray-500 text-sm" >Total Products</p>
    </div>
    <div class="mb-10">
      <p class="text-center font-bold text-gray-800 text-3xl">{{numberFormat(products.total_sold, '0,0')}}</p>
      <p class="text-center font-light text-gray-500 text-sm" >Total Sold</p>
    </div>
    <div class="mb-10">
      <p class="text-center font-bold text-gray-800 text-xl underline">Top Products</p>
      <p class="text-center font-light text-gray-500 text-sm">Total Unit Sold</p>
    </div>
    <div>
      <p class="w-full mb-4 font-bold" v-for="product in products.topcategories">{{product.category_name}} <span class="float-right">{{numberFormat(product.volume, '0,0')}}</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductDetails',
  computed: {
    products() {
      return this.$store.state.AIGeospatial.products;
    },
  },
};
</script>

<style scoped>
  .product {
    flex: 0 1 22%;
  }
</style>
